import Axios from 'axios'

export default class APICRUD {
  http() {
    //console.log(localStorage.getItem('token'))
    return Axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json'
      }
    })
  }
}
